export default __webpack_public_path__ + "static/media/ROX_4782.1ccdfc54.jpg";